import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { QA_BLOCKED_TOOLTIP } from "./constants";
import { formatDateTime, formatMoney, getStatusChipColor } from "./utils";

const Field = ({ label, value }) => (
  <Box sx={{ mb: 1.5 }}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" sx={{ mt: 0.25, wordBreak: "break-word" }}>
      {value ?? "—"}
    </Typography>
  </Box>
);

const SmsDetailDialog = ({
  open,
  onClose,
  data,
  loading,
  isAdmin,
  onRefreshStatus,
  onRetry,
  refreshing,
  retrying,
}) => {
  if (!data && !loading) return null;

  const internalKey = data?.internalStatusKey;
  const isQa = data?.isQaBlocked;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>جزئیات پیامک #{data?.id ?? ""}</DialogTitle>
      <DialogContent dividers>
        {data ? (
          <>
            <Box sx={{ mb: 2, display: "flex", gap: 1, flexWrap: "wrap" }}>
              <Chip
                size="small"
                label={data.internalStatusLabel || data.sendStatusTitle}
                color={getStatusChipColor(internalKey, isQa)}
              />
              {isQa ? (
                <Chip size="small" label="مسدود شده در حالت تست" color="warning" title={QA_BLOCKED_TOOLTIP} />
              ) : null}
              {data.isOtp ? <Chip size="small" label="OTP" color="info" /> : null}
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Field label="شناسه داخلی" value={data.id} />
                <Field label="شماره موبایل" value={data.receptor} />
                <Field label="نوع پیامک" value={data.monitoringCategoryLabel || data.smsType} />
                <Field label="هدف ارسال" value={data.purpose} />
                <Field label="شناسه کاربر مرتبط" value={data.userId} />
                <Field label="شناسه درخواست مرتبط" value={data.requestId} />
                <Field label="شماره پیگیری" value={data.referenceID || data.referenceId} />
              </Grid>
              <Grid item xs={12} md={6}>
                <Field label="وضعیت داخلی" value={data.internalStatusLabel} />
                <Field label="وضعیت سرویس‌دهنده" value={data.providerStatusLabel} />
                <Field label="پیام خطا" value={data.errorMessage} />
                <Field label="هزینه (ریال)" value={formatMoney(data.cost)} />
                <Field label="تاریخ ایجاد" value={formatDateTime(data.createDate)} />
                <Field label="تاریخ ارسال" value={formatDateTime(data.sendDate)} />
                <Field label="آخرین بروزرسانی" value={formatDateTime(data.updateDate)} />
                <Field label="شناسه پیام سرویس‌دهنده" value={data.messageId || data.messageid} />
                <Field label="تعداد تلاش ارسال" value={data.attemptCount} />
                <Field label="CorrelationId" value={data.correlationId} />
                <Field label="ارسال شده توسط" value={data.sentBy || "سیستم"} />
              </Grid>
              <Grid item xs={12}>
                <Divider sx={{ my: 1 }} />
                <Field label="متن پیامک" value={data.message} />
              </Grid>
            </Grid>
          </>
        ) : (
          <Typography color="text.secondary">در حال بارگذاری...</Typography>
        )}
      </DialogContent>
      <DialogActions>
        {data?.messageId > 0 ? (
          <Button onClick={() => onRefreshStatus(data.id)} disabled={refreshing}>
            بررسی وضعیت از سرویس‌دهنده
          </Button>
        ) : null}
        {isAdmin && data?.canRetry ? (
          <Button color="warning" onClick={() => onRetry(data.id)} disabled={retrying}>
            ارسال مجدد
          </Button>
        ) : null}
        <Button onClick={onClose}>بستن</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SmsDetailDialog;
